import type { SubscriptionPlan, SubscriptionTier } from '@/entities/subscription';

export const findPlan = (
  plans: SubscriptionPlan[] | undefined,
  tier: SubscriptionTier
): SubscriptionPlan | undefined => {
  return plans?.find((plan) => plan.tier === tier);
};
